import React from 'react';
import { Form, Button, Header, Divider } from 'semantic-ui-react';
import Field from '../Field';
import AffiliateDropdown from '../dropdowns/AffiliateDropdown';
import withLanguagesOptions from '../HOC/withLanguagesOptions';
import withPromoCodeOptions from '../HOC/withPromoCodeOptions';

const PromoCode = withPromoCodeOptions(
  ({ promoCodeId, errors, touched, onBlur, promoCodesOptions, onChange }) => (
    <Field error={errors} touched={touched}>
      <Form.Dropdown
        options={promoCodesOptions || []}
        name='promoCodeId'
        label='Promo Code *'
        placeholder='Promo Code'
        value={promoCodeId}
        onChange={onChange}
        onBlur={onBlur.bind(this, 'promoCodeId')}
        selection
        search
      />
    </Field>
  )
);

const TicketForm = ({
  Wrapper = Form,
  onHide,
  handleSubmit,
  onCancel,
  onChange,
  loading,
  values,
  errors,
  touched,
  onBlur,
  languagesOptions,
  edit,
  ticket
}) => {
  const { promoCode } = ticket || {};
  return (
    <Wrapper loading={loading}>
      <Header>{edit ? 'Edit' : 'New'} ticket</Header>
      <Form.Group widths='equal' onSubmit={handleSubmit}>
        <Field error={errors && errors.pnr} touched={touched && touched.pnr}>
          <Form.Input
            name='pnr'
            label='PNR'
            placeholder='PNR'
            value={values.pnr}
            onChange={onChange}
            onBlur={onBlur.bind(this, 'pnr')}
          />
        </Field>
        <Field
          error={errors && errors.token}
          touched={touched && touched.token}
        >
          <Form.Input
            name='token'
            label='Secret Token'
            placeholder='Secret Token'
            value={values.token}
            onChange={onChange}
            onBlur={onBlur.bind(this, 'token')}
          />
        </Field>
        <Field
          error={errors && errors.number}
          touched={touched && touched.number}
        >
          <Form.Input
            name='number'
            label='Number *'
            placeholder='Number'
            value={values.number}
            onChange={onChange}
            onBlur={onBlur.bind(this, 'number')}
          />
        </Field>
      </Form.Group>
      <Divider horizontal>PAX information:</Divider>
      <Form.Group widths='equal'>
        <Field
          error={errors && errors.passengerFirstName}
          touched={touched && touched.passengerFirstName}
        >
          <Form.Input
            name='passengerFirstName'
            label='Name *'
            placeholder='Name'
            value={values.passengerFirstName}
            onChange={onChange}
            onBlur={onBlur.bind(this, 'passengerFirstName')}
          />
        </Field>
        <Field
          error={errors && errors.passengerLastName}
          touched={touched && touched.passengerLastName}
        >
          <Form.Input
            name='passengerLastName'
            label='Surname *'
            placeholder='Surname'
            value={values.passengerLastName}
            onChange={onChange}
            onBlur={onBlur.bind(this, 'passengerLastName')}
          />
        </Field>
        <Field
          error={errors && errors.passengerPhone}
          touched={touched && touched.passengerPhone}
        >
          <Form.Input
            name='passengerPhone'
            label='Telephone *'
            placeholder='Telephone'
            value={values.passengerPhone}
            onChange={onChange}
            onBlur={onBlur.bind(this, 'passengerPhone')}
          />
        </Field>
      </Form.Group>
      <Form.Group widths='equal'>
        <Field
          error={errors && errors.passengerEmail}
          touched={touched && touched.passengerEmail}
        >
          <Form.Input
            name='passengerEmail'
            type='email'
            label='Email *'
            placeholder='Email'
            value={values.passengerEmail}
            onChange={onChange}
            onBlur={onBlur.bind(this, 'passengerEmail')}
          />
        </Field>
        <Field
          error={errors && errors.passengerLanguage}
          touched={touched && touched.passengerLanguage}
        >
          <Form.Dropdown
            options={languagesOptions || []}
            name='passengerLanguage'
            label='Language *'
            placeholder='Language'
            value={values.passengerLanguage}
            onChange={onChange}
            onBlur={onBlur.bind(this, 'passengerLanguage')}
            search
            selection
          />
        </Field>
        <Field
          error={errors && errors.employer}
          touched={touched && touched.employer}
        >
          <Form.Input
            name='employer'
            label='Employer *'
            placeholder='Employer'
            value={values.employer}
            onChange={onChange}
            onBlur={onBlur.bind(this, 'employer')}
          />
        </Field>
      </Form.Group>
      <Form.Group widths='equal'>
        <Field
          error={errors && errors.affiliateId}
          touched={touched && touched.affiliateId}
        >
          <AffiliateDropdown
            useId
            name='affiliateId'
            label='Affiliate *'
            placeholder='Affiliate'
            value={values.affiliateId}
            onChange={onChange}
            onBlur={onBlur.bind(this, 'affiliateId')}
          />
        </Field>
        <PromoCode
          promoCodeId={values.promoCodeId}
          error={errors && errors.promoCodeId}
          touched={touched && touched.promoCodeId}
          onBlur={onBlur}
          onChange={onChange}
          affiliateId={values.affiliateId}
          currentPromoCode={promoCode}
        />
      </Form.Group>
      <Button primary onClick={handleSubmit} content='Save' />
      <Button primary basic onClick={onCancel} type='submit' content='Cancel' />
      {onHide && (
        <Button primary basic onClick={onHide} type='button' content='Close' />
      )}
    </Wrapper>
  );
};

export default withLanguagesOptions(TicketForm);



// WEBPACK FOOTER //
// ./src/component/TicketFormPage/TicketForm.js